import { render, staticRenderFns } from "./TheShowMoreButton.vue?vue&type=template&id=3daacc1f&"
import script from "./TheShowMoreButton.vue?vue&type=script&lang=js&"
export * from "./TheShowMoreButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports